import React from "react";
import { Button, Icon, Tag } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import styles from "./sideMenu.scss";
import { PageRoute } from "../../models/enums";
import { navigateToLogin } from "../../history";
import { buildBaseUrl } from "../../services";
import { selectLoadedUser } from "../../routes/Auth/auth.ducks";
import { getIconUrl } from "../../services/asset";
import UserInfo from "./UserInfo";
import { selectUnreadCount } from "../../routes/Chat/chat.ducks";
import { selectSystemMessageUnreadCount } from "../../routes/SystemMessage/systemMessage.ducks";
import { setContactModalVisible } from "../App/actions";

export interface SideMenuProps {
  onSubmitAdClick: () => void;
  onMenuClose: () => void;
  visible: boolean;
}

const SideMenu = (props: SideMenuProps): JSX.Element => {
  const {
    onSubmitAdClick,
    onMenuClose,
    visible
  } = props;

  const chatUnreadCount = useSelector(selectUnreadCount);
  const systemUnreadCount = useSelector(selectSystemMessageUnreadCount);
  const unreadCount = (chatUnreadCount || 0) + (systemUnreadCount || 0);
  const dispatch = useDispatch();

  const user = useSelector(selectLoadedUser);
  const handleLogout = () => {
    window.location.replace(buildBaseUrl("/authentication/logout"));
  };

  const handleContainerClick = (e: any) => {
    e.stopPropagation();
  };

  const handleContactClick = () => {
    dispatch(setContactModalVisible(true));
  }

  return (
    <div
      className={visible ? styles.fadeIn : styles.fadeOut}
      onClick={onMenuClose}
      tabIndex={0}
      role="button"
    >
      <div
        className={visible ? styles.sideMenuOpen : styles.sideMenuClose}
        onClick={handleContainerClick}
        tabIndex={0}
        role="button"
      >
        <div className={styles.container}>
          <div className={styles.headerRow}>
            <a href="https://www.index.hr/" target="_blank" rel="noopener noreferrer nofollow">
              <img
                alt="Index.hr"
                src={getIconUrl("indexhr.svg")}
                className={styles.indexhrLogo}
              />
            </a>
            <Icon
              className={styles.closeButton}
              type="close"
              onClick={onMenuClose}
            />
          </div>

          {user && <UserInfo user={user} />}

          <Link
            title={"Naslovnica"}
            className={`uppercase ${styles.userMenuText}`}
            to={PageRoute.home}
            onClick={onMenuClose}
          >
            {"Naslovnica"}
          </Link>


          <Link
            title={"Moji oglasi"}
            className={`uppercase ${styles.userMenuText}`}
            to={PageRoute.myAd}
            onClick={onMenuClose}
            rel="noopener noreferrer nofollow"
          >
            {"Moji oglasi"}
          </Link>


          <Link
            title={"Poruke"}
            className={`uppercase ${styles.userMenuText}`}
            to={PageRoute.chats}
            onClick={onMenuClose}
            rel="noopener noreferrer nofollow"
          >
            {"Poruke"}
            {unreadCount > 0 && (
              <Tag className={styles.tag}>
                {unreadCount}
              </Tag>
            )}
          </Link>


          <Link
            title={"Ocjene"}
            className={`uppercase ${styles.userMenuText}`}
            to={PageRoute.myRatings}
            onClick={onMenuClose}
          >
            {"Ocjene"}
          </Link>

          <Link
            title={"Spremljeni oglasi"}
            className={`uppercase ${styles.userMenuText}`}
            to={PageRoute.favorite}
            onClick={onMenuClose}
            rel="noopener noreferrer nofollow"
          >
            {"Spremljeni oglasi"}
          </Link>

          <Link
            title={"Moje pretrage"}
            className={`uppercase ${styles.userMenuText}`}
            to={PageRoute.savedSearch}
            onClick={onMenuClose}
            rel="noopener noreferrer nofollow"
          >
            {"Moje pretrage"}
          </Link>
          {user && <React.Fragment>
            <React.Fragment>
              <Link
                title={"Financije"}
                className={`uppercase ${styles.userMenuText}`}
                to={PageRoute.finance}
                onClick={onMenuClose}
                rel="noopener noreferrer nofollow"
              >
                {"Financije"}
              </Link>

              <Link
                title={"Krediti"}
                className={`uppercase ${styles.userMenuText}`}
                to={PageRoute.credits}
                onClick={onMenuClose}
                rel="noopener noreferrer nofollow"
              >
                {"Krediti"}

                <Tag className={styles.tag}>
                  {user.storeCreditBalance}
                </Tag>
              </Link>
            </React.Fragment>

            <Link
              title={"Moji podaci"}
              className={`uppercase ${styles.userMenuText}`}
              to={PageRoute.profile}
              onClick={onMenuClose}
              rel="noopener noreferrer nofollow"
            >
              {"Moji podaci"}
            </Link>

            <Link
              title={"Postavke"}
              className={`uppercase ${styles.userMenuText}`}
              to={PageRoute.settings}
              onClick={onMenuClose}
              rel="noopener noreferrer nofollow"
            >
              {"Postavke"}
            </Link>

            <Link
              title={"Lozinka"}
              className={`uppercase ${styles.userMenuText}`}
              to={PageRoute.changePassword}
              onClick={onMenuClose}
              rel="noopener noreferrer nofollow"
            >
              {"Lozinka"}
            </Link>
          </React.Fragment>}
          <a
            title={"Prijavi problem ili prijedlog"}
            className={`uppercase ${styles.userMenuText}`}
            onClick={handleContactClick}
            rel="noopener noreferrer nofollow"
          >
            {"Prijavi problem ili prijedlog"}
          </a>

          <Button
            className={`uppercase ${styles.submitBtn}`}
            type="ghost"
            onClick={() => {
              onSubmitAdClick();
              onMenuClose();
            }}
          >
            <img
              alt={"Predaj oglas"}
              src={getIconUrl("plus_pink.svg")}
              className={styles.submitAdIcon}
            />
            {"Predaj oglas"}
          </Button>
          {user ? (
            <a
              className={`${styles.loginBtn} ${styles.userMenuText}`}
              rel="noopener noreferrer nofollow"
              role="presentation"
              onClick={handleLogout}
              title={"Odjava"}
            >
              <span>Odjava</span>
            </a>
          ) : (
            <span
              onClick={() => navigateToLogin()}
              rel="noopener noreferrer nofollow"
              role="button"
              tabIndex={0}
              className={styles.loginBtn}
            >
              <span>Prijavi se</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

SideMenu.defaultProps = {
  user: null,
  visible: false
};


export default SideMenu;



// WEBPACK FOOTER //
// ./src/containers/SideMenu/index.tsx